import axios from 'axios';
import UseSessionStore from '@/Stores/useSessionStore';
import { VICE_SESSION_PHASES, SESSION_LOG_ENDPOINT } from '@/Utils/vice-constants';

const sessionStore = UseSessionStore();

class LogService {
  /**
   * @param data
   * @returns {Promise<any>}
   */
  static async send(data) {
    try {
      await axios.post(SESSION_LOG_ENDPOINT, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {
      console.error(error.message);
    }
  }

  /**
   * @returns {string}
   */
  static getMessageMeta() {
    return `SessionID: ${sessionStore.sessionUniqueId}, ${
      sessionStore.isClinician ? 'Clinician' : 'Participant'
    }: ${sessionStore.authUser?.name} (${sessionStore.authUser?.id})`;
  }

  /**
   * @param track
   * @param status
   * @returns {Promise<void>}
   */
  static async logLocalTrack(track, status) {
    try {
      const phaseName = Object.keys(VICE_SESSION_PHASES).find(
        (key) => VICE_SESSION_PHASES[key] === sessionStore.currentPhase,
      );
      const data = {
        status,
        phaseState: `${sessionStore.hasLivePhase ? 'Live' : 'Waiting'} ${phaseName}`,
        time: new Date().toLocaleTimeString(),
        deviceId: track.getDeviceId(),
        deviceLabel: track.track.label,
        trackId: track.track.id,
        trackType: track.track.kind,
        trackMuted: track.track.muted,
        trackState: track.track.readyState,
      };

      await this.send({
        message: `LocalTrackEvent: [${this.getMessageMeta()}]`,
        data,
      });
    } catch (error) {
      console.error(error.message);
    }
  }

  /**
   * @param data
   * @returns {Promise<void>}
   */
  static async logDeviceListChanged(data) {
    try {
      await this.send({
        message: `DevicesListChanged: [${this.getMessageMeta()}]`,
        data,
      });
    } catch (error) {
      console.error(error.message);
    }
  }

  /**
   * @param user
   * @param data
   * @returns {Promise<void>}
   */
  static async logConnectionCheckData(user, data) {
    try {
      await this.send({
        message: `Connection check: [${user.role}: ${user.name} (${user.id})]`,
        data,
      });
    } catch (error) {
      console.error(error.message);
    }
  }
}

export default LogService;
